import BaseApiService from './BaseApiService.js';

class IdentifierService extends BaseApiService {
  
  // Fetch sequence configs and values
  async getConfigs() {
    return this.makeRequest('/api/admin/identifier-config/get', { method: 'GET' });
  }

  // Save sequence configuration changes
  async saveConfig(payload) {
    return this.makeRequest('/api/admin/identifier-config/save', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  // Reset a sequence value
  async resetSequence(payload) {
    return this.makeRequest('/api/admin/identifier-config/reset', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  // --- Roll Number Settings ---
  
  async getRollNumberSettings(academicYear) {
    const query = academicYear ? `?academicYear=${encodeURIComponent(academicYear)}` : '';
    return this.makeRequest(`/api/admin/college/roll-number-settings${query}`, { method: 'GET' });
  }

  async saveRollNumberSettings(payload) {
    return this.makeRequest('/api/admin/college/roll-number-settings', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  async regenerateRollNumbers(payload) {
    return this.makeRequest('/api/admin/college/roll-number-settings/regenerate', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  async getNextRollNumber(className, sectionName) {
    const params = new URLSearchParams();
    if (className) params.append('class', className);
    if (sectionName) params.append('section', sectionName);
    return this.makeRequest(`/api/admin/college/roll-number-settings/next?${params.toString()}`, { method: 'GET' });
  }
}

const identifierService = new IdentifierService();
export default identifierService;
